import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
/* import scrollSpeed from "./plugins/scrollSpeed"; */
import { loadFonts } from "./plugins/webfontloader";
import { createMetaManager, plugin as metaPlugin } from "vue-meta";
import VueCookieAcceptDecline from "vue-cookie-accept-decline";
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";
import VueGtag from "vue-gtag";

loadFonts();

const appVue = createApp(App);
appVue.component("vue-cookie-accept-decline", VueCookieAcceptDecline);

appVue
  .use(
    VueGtag,
    {
      config: { id: "G-LVV1X8D1L7" },
      appName: "GREENWORLD GBR",
      pageTrackerScreenviewEnabled: true,
      enabled: false,
      bootstrap: true,
      onError(error) {
        console.log(error);
      },
    },
    router
  )
  .use(router)
  .use(store)
  .use(vuetify)
  /* .use(scrollSpeed) */
  .use(createMetaManager())
  .use(metaPlugin);

appVue.mount("#app");
